export default {"src":"/_next/static/media/SHCO.b66c5364.svg","height":18,"width":18};